import cn from 'classnames';
import { Link } from 'react-router-dom';
import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { useProfile } from 'modules/auth/hooks';
import { useDisableMFA } from 'modules/auth/modals/DisableMFA';
import { CaretDown as Down, ShieldSlash } from '@phosphor-icons/react';
import ThumbIcon from './ThumbIcon';

const userNavigation = [{ name: 'Logout', href: '/logout' }];

function HeaderProfile() {
  const [profile] = useProfile();
  const openDisableMFA = useDisableMFA();
  const name = `${profile?.profile?.first_name} ${profile?.profile?.last_name}`;
  const role = profile?.role?.name;
  const email = profile?.email;
  return (
    <div className="relative flex items-center">
      <ThumbIcon className="h-8 w-8 rounded-full" alt={name} />
      <div className="font-[400] text-neutral-600 ml-3">
        <div className="text-sm">{name}</div>
        <div className="text-xs">{role}</div>
      </div>
      <div className="flex ml-10 space-x-3">
        <Menu as="div" className="relative">
          {({ open }) => (
            <>
              <div>
                <Menu.Button className="max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-600 focus-visible:ring-offset-2">
                  <span className="sr-only">Open user menu</span>
                  <Down className="text-brand-600" />
                </Menu.Button>
              </div>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
                show={open}
              >
                <Menu.Items className="origin-top-right absolute right-0 mt-2 w-64 rounded-md bg-white border border-neutral-200 shadow-popover focus:outline-none pb-4 pt-2 z-50">
                  <div className="flex px-3 py-2 space-x-2 border-b border-neutral-200 text-neutral-500">
                    Signed in as
                  </div>
                  <div className="flex px-3 py-2 space-x-2 border-b border-neutral-200 items-center">
                    <ThumbIcon className="h-12 w-12 rounded-full" alt={name} />
                    <div>
                      <div className="">{name}</div>
                      <div className="text-sm text-neutral-500">{email}</div>
                    </div>
                  </div>
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        type="button"
                        onClick={openDisableMFA}
                        className={cn(
                          active ? 'bg-neutral-200' : '',
                          'flex items-center gap-2 w-full px-4 py-2 text-sm text-red-600',
                        )}
                      >
                        <ShieldSlash size={16} />
                        Disable MFA
                      </button>
                    )}
                  </Menu.Item>
                  {userNavigation.map((item) => (
                    <Menu.Item key={item.name}>
                      {({ active }) => (
                        <Link
                          to={item.href}
                          className={cn(
                            active ? 'bg-neutral-200' : '',
                            'block px-4 py-2 text-sm text-neutral-900',
                          )}
                        >
                          {item.name}
                        </Link>
                      )}
                    </Menu.Item>
                  ))}
                </Menu.Items>
              </Transition>
            </>
          )}
        </Menu>
      </div>
    </div>
  );
}

HeaderProfile.propTypes = {};

export default HeaderProfile;
